// Copyright (c) 2017 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import AuditCount, {getDefaultState as getAuditCountDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-count';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import ClosingAccountChanges, {getDefaultState as getClosingAccountChangesDefaultState} from './closing-account';
import Dealer, {getDefaultState as getDealerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DealerHierarchyFacet, {getDefaultState as getDealerHierarchyFacetDefaultState} from '../../shared/state/dealer-hierarchy-facet';
import DuplicatePinPlateView, {getDefaultState as getDuplicatePinPlateViewDefaultState} from './duplicate-pin-plate';
import FilteredTerritories, {getDefaultState as getFilteredTerritoriesDefaultState} from '../../shared/state/filtered-territories';
import LaborRateChanges, {getDefaultState as getLaborRateChangesDefaultState} from './labor-rate-changes';
import MachineStatusUpdates, {getDefaultState as getMachineStatusUpdatesDefaultState} from './machine-status-updates';
import MeasurementReading, {getDefaultState as getMeasurementReadingDefaultState} from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import MeasurementReadingView, {getDefaultState as getMeasurementReadingViewDefaultState} from './amount-of-use';
import PipCode, {getDefaultState as getPipCodeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import PipCodeRequests, {getDefaultState as getPipCodeRequestsDefaultState} from './pip-code-requests';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from './search-by-dropdown';
import SelectedSpaLevels, {getDefaultState as getSelectedSpaLevelsDefaultState} from './selected-spa-levels';
import SpaClaims, {getDefaultState as getSpaClaimsDefaultState} from './spa-claims';
import StatusChange, {getDefaultState as getStatusChangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';
import TcsmApproveDenyModal, {getDefaultState as getTcsmApproveDenyModalDefaultState} from './tcsm-approve-deny-modal';
import TcsmSettings, {getDefaultState as getTcsmSettingsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/tcsm-settings';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from '../../../shared/services/get-default-filter-state';
import t from 'tcomb';

const State = t.struct({
    account: Dealer,
    amountOfUseItemToUpdate: MeasurementReading,
    amountOfUseLength: t.Number,
    amountOfUseModal: TcsmApproveDenyModal,
    amountOfUseSearchFilters: SearchFilters,
    amountOfUseView: MeasurementReadingView,
    auditCount: AuditCount,
    busyCounter: BusyCounter,
    closingAccountChanges: ClosingAccountChanges,
    closingAccountIndex: t.Number,
    closingAccountLength: t.Number,
    closingAccountSearchFilters: SearchFilters,
    duplicatePinPlateLength: t.Number,
    duplicatePinPlateSearchFilters: SearchFilters,
    duplicatePinPlateView: DuplicatePinPlateView,
    facetFilterText: t.String,
    filteredTerritories: FilteredTerritories,
    initialLoad: t.Bool,
    laborRateChanges: LaborRateChanges,
    laborRateChangesLength: t.Number,
    laborRateChangesSearchFilters: SearchFilters,
    machineStatusItemToUpdate: StatusChange,
    machineStatusModal: TcsmApproveDenyModal,
    machineStatusSearchFilters: SearchFilters,
    machineStatusUpdates: MachineStatusUpdates,
    pipCodeRequestItemToUpdate: PipCode,
    pipCodeRequestModal: TcsmApproveDenyModal,
    pipCodeRequestSearchFilters: SearchFilters,
    pipCodeRequests: PipCodeRequests,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchQueryString: t.String,
    selectedSpaLevels: SelectedSpaLevels,
    specialAllowanceClaims: SpaClaims,
    specialAllowanceClaimsSearchFilters: SearchFilters,
    tcsmSettings: TcsmSettings,
    wipFacets: DealerHierarchyFacet
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        account: getDealerDefaultState(),
        amountOfUseItemToUpdate: getMeasurementReadingDefaultState(),
        amountOfUseLength: 0,
        amountOfUseModal: getTcsmApproveDenyModalDefaultState(),
        amountOfUseSearchFilters: getSearchFiltersDefaultState('', '', ['date'], 'ASC'),
        amountOfUseView: getMeasurementReadingViewDefaultState(),
        auditCount: getAuditCountDefaultState(),
        busyCounter: getBusyCounterDefaultState(),
        closingAccountChanges: getClosingAccountChangesDefaultState(),
        closingAccountIndex: 0,
        closingAccountLength: 0,
        closingAccountSearchFilters: getSearchFiltersDefaultState('', '', ['businessEndDate'], 'ASC'),
        duplicatePinPlateLength: 0,
        duplicatePinPlateSearchFilters: getSearchFiltersDefaultState('', '', ['dateSubmmited'], 'ASC'),
        duplicatePinPlateView: getDuplicatePinPlateViewDefaultState(),
        facetFilterText: '',
        filteredTerritories: getFilteredTerritoriesDefaultState(),
        initialLoad: true,
        laborRateChanges: getLaborRateChangesDefaultState(),
        laborRateChangesLength: 0,
        laborRateChangesSearchFilters: getSearchFiltersDefaultState('', '', ['requestDate'], 'ASC'),
        machineStatusItemToUpdate: getStatusChangeDefaultState(),
        machineStatusModal: getTcsmApproveDenyModalDefaultState(),
        machineStatusSearchFilters: getSearchFiltersDefaultState('', '', ['createdDate'], 'ASC'),
        machineStatusUpdates: getMachineStatusUpdatesDefaultState(),
        pipCodeRequestItemToUpdate: getPipCodeDefaultState(),
        pipCodeRequestModal: getTcsmApproveDenyModalDefaultState(),
        pipCodeRequestSearchFilters: getSearchFiltersDefaultState('', '', ['createDate'], 'ASC'),
        pipCodeRequests: getPipCodeRequestsDefaultState(),
        reportsAccordion: getAccordionDefaultState('tcsm-reports-accordion'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchQueryString: '',
        selectedSpaLevels: getSelectedSpaLevelsDefaultState(),
        specialAllowanceClaims: getSpaClaimsDefaultState(),
        specialAllowanceClaimsSearchFilters: getSearchFiltersDefaultState('', '', ['submittedDate'], 'ASC'),
        tcsmSettings: getTcsmSettingsDefaultState(),
        wipFacets: getDealerHierarchyFacetDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/index.js